import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { Subtitles } from './Subtitles';

export type SubtitlesContainerProps = {};

export function SubtitlesContainer(_props: SubtitlesContainerProps) {
  const dispatch = useDispatch();
  const subtitles = useSelector(selectors.base.$subtitles);
  const { editMode } = useSelector(selectors.raw.$rawAppState);

  if (!subtitles || editMode !== 'scene') {
    return null;
  }

  return <Subtitles value={subtitles} />;
}

export default SubtitlesContainer;
